import { render, staticRenderFns } from "./settlement-purchases-promoter.vue?vue&type=template&id=0f942a0c&scoped=true&"
import script from "./settlement-purchases-promoter.vue?vue&type=script&lang=js&"
export * from "./settlement-purchases-promoter.vue?vue&type=script&lang=js&"
import style0 from "./settlement-purchases-promoter.vue?vue&type=style&index=0&id=0f942a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f942a0c",
  null
  
)

export default component.exports